var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box",style:(_vm.mobile_flag ? 'padding: 0 31px;' : 'padding: 0 71px;')},[_c('img',{attrs:{"src":_vm.bannerPic,"alt":"图片显示异常"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }